import OnMountIsLoadedAndBotAnswerWithButtonsMixin from '@/mixins/on-mount-is-loaded-and-bot-answer-with-buttons';
import { Component } from 'vue-property-decorator';

@Component
export default class BotTextMessage extends OnMountIsLoadedAndBotAnswerWithButtonsMixin {}
